<template>
  <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="0px" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="dataForm">
    <!-- 公司注册地址 -->
    <div class="pb22 messageWrap">
      <p class="messageTitle">
        {{ $t("enroll.establish.malaysia.registeredTitle") }}
      </p>
      <div class="pt30">
        <el-form-item prop="registeredOfficeType" ref="registeredOfficeType" class="mb0">
          <el-radio-group v-model="dataForm.registeredOfficeType">
            <div v-if="applymentHasRegisteredAddress">
              <el-radio :label="1">
                <span class="fs14">{{ $t("enroll.establish.malaysia.regOptionMain") }}</span>
              </el-radio>
            </div>
            <div class="pt12">
              <el-radio :label="2">
                <span class="fs14">{{ $t("enroll.establish.malaysia.serviceOtherMain") }}</span>
                <div class="hg6"></div>
                <span class="fs12 black88 pl20 lh20">{{ $t("enroll.establish.otherTransferMinor") }}</span>
              </el-radio>
            </div>
          </el-radio-group>
          <!-- 采用其他注册地址 -->
          <div class="fs12 pl20 pt14" v-if="dataForm.registeredOfficeType == 2">
            <div class="clearfix">
              <el-form-item prop="registeredOfficeAddressLine1" ref="registeredOfficeAddressLine1" class="mb10 mr20 fl">
                <p class="fs12">{{ $t("enroll.establish.malaysia.addressLine1") }}</p>
                <el-input v-model="dataForm.registeredOfficeAddressLine1" :placeholder="$t('common.placeholder.enter')" class="wd400 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="registeredOfficeAddressLine2" ref="registeredOfficeAddressLine2" class="mb10 mr20 fl">
                <p class="fs12">{{ $t("enroll.establish.malaysia.addressLine2") }}</p>
                <el-input v-model="dataForm.registeredOfficeAddressLine2" :placeholder="$t('common.placeholder.enter')" class="wd400 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="registeredOfficeAddressLine3" ref="registeredOfficeAddressLine3" class="mb10 fl">
                <p class="fs12">{{ $t("enroll.establish.malaysia.addressLine3") }}</p>
                <el-input v-model="dataForm.registeredOfficeAddressLine3" :placeholder="$t('common.placeholder.enter')" class="wd400 fs12"></el-input>
              </el-form-item>
            </div>
            <div class="clearfix">
              <el-form-item prop="registeredOfficeCountry" ref="registeredOfficeCountry" class="mb10 mr20 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.country") }}</p>
                <el-input v-model="dataForm.registeredOfficeCountry" disabled class="wd90 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="registeredOfficeState" ref="registeredOfficeState" class="mb10 mr20 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.malaysia.state") }}</p>
                <el-select v-model="dataForm.registeredOfficeState" :placeholder="$t('common.placeholder.select')" filterable class="wd290">
                  <el-option v-for="item in byCountryFormatList('provinceOrStateData')" :key="`registered-${item.value}`" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="registeredOfficeCity" ref="registeredOfficeCity" class="mb10 mr20 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.city") }}</p>
                <el-input v-model="dataForm.registeredOfficeCity" :placeholder="$t('common.placeholder.enter')" class="wd300 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="registeredOfficePostalCode" ref="registeredOfficePostalCode" class="mb10 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.code") }}</p>
                <el-input v-model="dataForm.registeredOfficePostalCode" :placeholder="$t('common.placeholder.enter')" class="wd150 fs12"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </div>
    </div>

    <!-- 服务地址 -->
    <div class="pt50 pb22 messageWrap">
      <p class="messageTitle">{{ $t("enroll.establish.malaysia.serviceAddressTitle") }}</p>
      <div class="pt30">
        <el-form-item prop="serviceAddressType" ref="serviceAddressType" class="mb0">
          <el-radio-group v-model="dataForm.serviceAddressType">
            <div>
              <el-radio :label="1">
                <span class="fs14">{{ $t("enroll.establish.malaysia.sameAsRegisteredAddress") }}</span>
              </el-radio>
            </div>
            <div class="pt12">
              <el-radio :label="2">
                <span class="fs14">{{ $t("enroll.establish.malaysia.serviceOtherMain") }}</span>
                <!-- <div class="hg6"></div> -->
                <!-- <span class="fs12 black88 pl20 lh20">{{ $t("enroll.establish.otherTransferMinor") }}</span> -->
              </el-radio>
            </div>
          </el-radio-group>
          <!-- 采用其他注册地址 -->
          <div class="fs12 pl20 pt14" v-if="dataForm.serviceAddressType == 2">
            <div class="clearfix">
              <el-form-item prop="serviceAddressLine1" ref="serviceAddressLine1" class="mb10 mr20 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.malaysia.addressLine1") }}</p>
                <el-input v-model="dataForm.serviceAddressLine1" :placeholder="$t('common.placeholder.enter')" class="wd400 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="serviceAddressLine2" ref="serviceAddressLine2" class="mb10 mr20 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.malaysia.addressLine2") }}</p>
                <el-input v-model="dataForm.serviceAddressLine2" :placeholder="$t('common.placeholder.enter')" class="wd400 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="serviceAddressLine3" ref="serviceAddressLine3" class="mb10 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.malaysia.addressLine3") }}</p>
                <el-input v-model="dataForm.serviceAddressLine3" :placeholder="$t('common.placeholder.enter')" class="wd400 fs12"></el-input>
              </el-form-item>
            </div>
            <div class="clearfix">
              <el-form-item prop="serviceAddressCountry" ref="serviceAddressCountry" class="mb10 mr20 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.country") }}</p>
                <el-input v-model="dataForm.serviceAddressCountry" disabled class="wd90 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="serviceAddressState" ref="serviceAddressState" class="mb10 mr20 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.malaysia.state") }}</p>
                <el-select v-model="dataForm.serviceAddressState" :placeholder="$t('common.placeholder.select')" filterable class="wd290">
                  <el-option v-for="item in byCountryFormatList('provinceOrStateData')" :key="`service-${item.value}`" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="serviceAddressCity" ref="serviceAddressCity" class="mb10 mr20 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.city") }}</p>
                <el-input v-model="dataForm.serviceAddressCity" :placeholder="$t('common.placeholder.enter')" class="wd300 fs12"></el-input>
              </el-form-item>
              <el-form-item prop="serviceAddressPostalCode" ref="serviceAddressPostalCode" class="mb10 fl">
                <p class="fs12 mr4">{{ $t("enroll.establish.code") }}</p>
                <el-input v-model="dataForm.serviceAddressPostalCode" :placeholder="$t('common.placeholder.enter')" class="wd150 fs12"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </div>
    </div>

    <div v-if="applymentDetail.businessType == 'COMPANY_INCORPORATION'">
      <!-- 财务年度 -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">{{ $t("enroll.establish.yearTitle") }}</p>
        <div class="pt30 flex-row">
          <el-form-item prop="month" ref="month" class="mr40">
            <span class="mr6">{{ $t("enroll.establish.month") }}</span>
            <el-select v-model="dataForm.month" :placeholder="$t('common.placeholder.select')" class="wd140">
              <el-option v-for="nub in 12" :key="'month' + nub" :label="nub" :value="nub"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="date" ref="date">
            <span class="mr6">{{ $t("enroll.establish.date") }}</span>
            <el-select v-model="dataForm.date" :placeholder="$t('common.placeholder.select')" class="wd140">
              <el-option v-for="nub in 31" :key="'date' + nub" :label="nub" :value="nub"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!-- 财务期间 -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">{{ $t("enroll.establish.periodTitle") }}</p>
        <div class="pt30">
          <el-form-item prop="financialYearPeriod" ref="financialYearPeriod">
            <el-select v-model="dataForm.financialYearPeriod" :placeholder="$t('common.placeholder.select')" class="wd500">
              <el-option v-for="item in byCountryFormatList('financialPeriodTypeData')" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!-- 股本信息 -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">{{ $t("enroll.establish.capitalTitle") }}</p>
        <div class="pt30">
          <el-form-item prop="companyMemberList" ref="companyMemberList">
            <sharehold-information :isReadonly="isReadonly" :isMalaysia="true" />
          </el-form-item>
        </div>
      </div>

      <!-- 公司章程 -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.establish.constitutionTitle") }}
        </p>
        <div class="pt30">
          <el-form-item prop="isCustomizedConstitution" ref="isCustomizedConstitution">
            <el-radio-group v-model="dataForm.isCustomizedConstitution">
              <div>
                <el-radio :label="0">
                  <span class="fs14">{{ $t("enroll.establish.malaysia.constitutionOption01") }}</span>
                  <div></div>
                  <span class="ml4 fs12 black88 pl20 lh20">{{ $t("enroll.establish.malaysia.constitutionOption01Desc") }}</span>
                </el-radio>
              </div>
              <div class="pt12">
                <el-radio :label="1">{{ $t("enroll.establish.malaysia.constitutionOption02") }}</el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>

      <!-- 行业性质是否特殊、是否已取得相关其他政府机构的批准？ -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.establish.authoritiesTitle") }}
          <el-popover placement="bottom" trigger="hover">
            <div class="linkWrap">
              <p class="fs12">{{ $t("common.reference") }}</p>
              <p class="pt2">
                <a href="https://www.acra.gov.sg/how-to-guides/before-you-start/referral-authorities" target="_blank" class="lh14">
                  https://www.acra.gov.sg/how-to-guides/before-you-start/referral-authorities
                </a>
              </p>
            </div>
            <span slot="reference" class="fs16 lucency otn el-icon-question"></span>
          </el-popover>
        </p>
        <div class="pt20">
          <el-form-item class="mb6" prop="hasObtainedApproval" ref="hasObtainedApproval">
            <el-radio-group v-model="dataForm.hasObtainedApproval">
              <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
              <el-radio :label="0">{{ $t("enroll.establish.assist") }}</el-radio>
            </el-radio-group>
            <!-- 选中yes时 -->
            <div class="fs12 pt10 flex-row yesWrap" v-if="dataForm.hasObtainedApproval == 1">
              <el-form-item prop="approvalAuthorities" ref="approvalAuthorities" class="mb0">
                <el-checkbox-group v-model="dataForm.approvalAuthorities" class="clearfix">
                  <div v-for="item in byCountryFormatList('governmentData')" :key="`ratify-${item.value}`" class="fl mb12 mupiterSelect">
                    <el-checkbox :label="item.value" class="fxVer">
                      <span class="fs14 preLine">{{ item.label }}</span>
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-form-item>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
import ShareholdInformation from "../../components/ShareholdInformation";
import { validateLocation, strToNum } from "@/utils/common";
import { mapState, mapGetters } from "vuex";

export default {
  name: "EnrollEstablishMalaysia",
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ShareholdInformation,
  },
  data() {
    return {
      dataForm: {
        month: null,
        date: null,
        financialYearPeriod: null,
        companyMemberList: [],
        registeredOfficeType: null,
        registeredOfficeAddressLine1: null,
        registeredOfficeAddressLine2: null,
        registeredOfficeAddressLine3: null,
        registeredOfficeCountry: "Malaysia",
        registeredOfficeState: null,
        registeredOfficeCity: null,
        registeredOfficePostalCode: null,
        serviceAddressType: null,
        serviceAddressLine1: null,
        serviceAddressLine2: null,
        serviceAddressLine3: null,
        serviceAddressCountry: "Malaysia",
        serviceAddressState: null,
        serviceAddressCity: null,
        serviceAddressPostalCode: null,
        isCustomizedConstitution: null,
        hasObtainedApproval: null,
        approvalAuthorities: [],
      },
      rules: {
        month: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        date: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        financialYearPeriod: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        companyMemberList: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.replenish"),
            trigger: "submit",
          },
        ],
        registeredOfficeType: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        registeredOfficeAddressLine1: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        registeredOfficeState: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        registeredOfficeCity: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        registeredOfficeCountry: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        registeredOfficePostalCode: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        serviceAddressType: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        serviceAddressLine1: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        serviceAddressCountry: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        serviceAddressState: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        serviceAddressCity: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        serviceAddressPostalCode: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        isCustomizedConstitution: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        hasObtainedApproval: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        approvalAuthorities: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasRegisteredAddress"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
  },
  methods: {
    // 数据初始化处理
    dataInit() {
      const detail = JSON.parse(JSON.stringify(this.applymentDetail));
      const [month, date] = (detail.financialYearEnd || "").split("/").map(v => Number(v) || null);
      this.dataForm = {
        month,
        date,
        financialYearPeriod: detail.financialYearPeriod,
        companyMemberList: detail.companyMemberList || [],
        registeredOfficeType: detail.registeredOfficeType,
        registeredOfficeAddressLine1: detail.registeredOfficeAddressLine1,
        registeredOfficeAddressLine2: detail.registeredOfficeAddressLine2,
        registeredOfficeAddressLine3: detail.registeredOfficeAddressLine3,
        registeredOfficeCountry: "Malaysia",
        registeredOfficeState: detail.registeredOfficeState,
        registeredOfficeCity: detail.registeredOfficeCity,
        registeredOfficePostalCode: detail.registeredOfficePostalCode,
        serviceAddressType: detail.serviceAddressType,
        serviceAddressLine1: detail.serviceAddressLine1,
        serviceAddressLine2: detail.serviceAddressLine2,
        serviceAddressLine3: detail.serviceAddressLine3,
        serviceAddressCountry: "Malaysia",
        serviceAddressState: detail.serviceAddressState,
        serviceAddressCity: detail.serviceAddressCity,
        serviceAddressPostalCode: detail.serviceAddressPostalCode,
        isCustomizedConstitution: strToNum(detail.isCustomizedConstitution),
        hasObtainedApproval: strToNum(detail.hasObtainedApproval),
        approvalAuthorities: detail.approvalAuthorities || [],
      };
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      return {
        ...this.dataForm,
        financialYearEnd: this.dataForm.month + "/" + this.dataForm.date,
      };
    },
    // 触发必填校验(由父级触发) - 仅下一步时调用
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
  },
  created() {
    // isReadonly 时，applymentDetail 已存在于 vuex，自行初始化数据
    if (this.isReadonly) {
      this.dataInit();
    }
  },
};
</script>

<style lang="scss" scoped>
.messageTitle {
  border-radius: 2px;
  font-size: 16px;
  line-height: 1em;
  font-weight: 600;
}

.messageTitle:before {
  content: "*";
  margin-right: 4px;
  color: #f56c6c;
}

.yesWrap {
  ::v-deep {
    .el-checkbox__input {
      line-height: 0;
    }
  }
}

.mupiterSelect {
  width: 600px;
  margin-right: 0px;
  padding-right: 30px;
  box-sizing: border-box;
}

::v-deep {
  .el-input.is-disabled .el-input__inner {
    color: #011a45 !important;
  }
}
</style>
